import { useMemo } from 'react'

import { useTelemetryCredentials } from '@/feature/telemetry/api/useMyTelemetryCredentials'
import { GeoFenceEvents } from '@/feature/observatory/types/GeoFenceEvent.types'

import { useNetworkRequest } from '@/lib/utils/request'

export const useGeoFenceEvents = (
  id?: number | null,
): ReturnType<typeof useNetworkRequest<GeoFenceEvents>> => {
  const { data: credentials } = useTelemetryCredentials()

  const eventsApiUrl = useMemo((): Parameters<typeof useNetworkRequest<GeoFenceEvents>>[0] => {
    if (credentials?.telemetryFleetName && id !== null) {
      return {
        url: `v1/geofences/${credentials?.telemetryFleetName}/${id == null ? 'all-events' : `events/${id}`}/`,
        config: {
          timeout: 60_000,
        },
      }
    }
    // Skip call events api
    return null
  }, [credentials?.telemetryFleetName, id])

  return useNetworkRequest<GeoFenceEvents>(eventsApiUrl)
}

export const useSingleGeoFenceEvents = (
  id?: number,
): ReturnType<typeof useNetworkRequest<GeoFenceEvents>> => {
  const { data: credentials } = useTelemetryCredentials()

  const eventsApiUrl = useMemo((): Parameters<typeof useNetworkRequest<GeoFenceEvents>>[0] => {
    if (credentials?.telemetryFleetName && id !== null && id !== undefined) {
      return {
        url: `v1/geofences/${credentials?.telemetryFleetName}/events/${id}/`,
        config: {
          timeout: 60_000,
        },
      }
    }
    // Skip call events api
    return null
  }, [credentials?.telemetryFleetName, id])

  return useNetworkRequest<GeoFenceEvents>(eventsApiUrl)
}
